import { Component } from '@angular/core';

import  { App, NavParams, AlertController, NavController  } from 'ionic-angular';

import { Toast } from 'ionic-native';

import { UserData } from '../../providers/user-data';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';


@Component({
  templateUrl: 'build/pages/job-info/job-info.html'
})
export class JobInfo {

  jobinfos: any;

 username: string;
 jobid: string;

  constructor(public navParams: NavParams,private alertController: AlertController, public user: UserData,
    private http: Http,
     public app: App,
      public navCtrl: NavController
      ) {


    this.jobid = navParams.data;
        this.loadjobs();
  }

 
  ionViewDidEnter() {
    this.app.setTitle('Job Info');
   
  }




  loadjobs() {

  this.user.getUsername().then((username) => {
    this.username = username;
 var url = 'http://letpco.co.uk/api/v1/jobview?authkey='+this.username+'&jobid='+this.jobid;

          this.http.get(url).subscribe(res => {

 this.jobinfos = res.json().data;
      });

 return 'hi';

  });
    }



  showPrompt() {
    let prompt = this.alertController.create({
      title: 'Bid Amount',
      message: "Enter the Bid Amount",
      inputs: [
        {
          name: 'title',
          placeholder: '50'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            this.toast('Canceled');
          }
        },
        {
          text: 'Save',
          handler: data => {
       

          if(parseFloat(data.title))
          {

var url = 'http://letpco.co.uk/api/v1/bid?authkey='+this.username+'&jobid='+this.jobid+'&fare='+parseFloat(data.title);

          this.http.get(url).subscribe(res => {


          this.loadjobs();

           this.toast(res.json().key);


      });

          }
          else
          {
           this.toast('Enter Valid Digits');
          }

           
              this.loadjobs();
          }
        }
      ]
    });
    prompt.present();
  }

toast(msg: string)
{
 
Toast.show(msg, '5000', 'center').subscribe(
  toast => {
    
  }
);

  }





   showConfirm(fare: string) {
    let confirm = this.alertController.create({
      title: 'Grab for  £ '+fare,
      message: 'Make Sure you can do this job before Grab or Bid !',
      buttons: [
        {
          text: 'Canceled',
          handler: () => {
             this.toast('Canceled');
          }
        },
        {
          text: 'Accept ',
          handler: () => {

          var url = 'http://letpco.co.uk/api/v1/grab?authkey='+this.username+'&jobid='+this.jobid;

          this.http.get(url).subscribe(res => {


          this.loadjobs();

           this.toast(res.json().key);


      });



      
          }
        }
      ]
    });
    confirm.present();
  }
}
